
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Brite Tony Wright blieb im Jahr 2007 266 Stunden wach, also etwas über elf Tage. Offizieller Weltrekordhalter im Nicht-Schlafen ist dennoch nach wie vor der Amerikaner Randy Gardner, der bereits im Jahr 1965 anlässlich einer Wissenschaftsveranstaltung während 264 Stunden (also elf volle Tage) auf Schlaf verzichtete und es so ins «Guinnessbuch der Rekorde» schaffte. Diesen Platz macht ihm niemand streitig: Guinness berücksichtigt seit einigen Jahren keine Versuche mehr, den Weltrekord im Nicht-Schlafen zu brechen. Zu gefährlich und gesundheitsschädigend seien diese Experimente – auch laut unbestreitbaren wissenschaftlichen Beweisen. `}<br /><br />{`
Trotzdem sind Wright und Gardner nicht allein: Viele weitere Personen blieben im Rahmen diverser Versuche bis zu zehn Tage wach. `}<M mdxType="M">{`Interessant ist dabei, dass keine dieser Personen anschliessend von ernsthaften medizinischen oder neurologischen Problemen berichtete.`}</M>{` Allerdings hatten alle nach einigen Tagen mit Konzentrations- und Wahrnehmungsschwächen zu kämpfen, die aber nach ein, zwei erholsamen Nächten wieder verschwanden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;